/* eslint-disable */
export const partAttributesStub: any = {
    "region": {
        "title": "Region",
        "title_column_name": "Region",
        "description": "Regions currently covered in the Auto Care vehicle database (e.g., USA, Canada, and Mexico)",
        "column_name": "region",
        "attribute_name": "region",
        "is_range": false,
        "vcdb_id": true,
        "default": true,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "region.name",
            "id": "region.id",
            "mysql_id_field": "Region.RegionID"
        }
    },
    "vehicleType": {
        "title": "Vehicle type",
        "title_column_name": "Vehicle type",
        "description": "Types of vehicles (e.g., motorcycle, car, truck, etc.)",
        "column_name": "vehicleType",
        "attribute_name": "vehicleType",
        "is_range": false,
        "vcdb_id": true,
        "default": true,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "baseVehicle.model.vehicleType.name",
            "id": "baseVehicle.model.vehicleType.id",
            "mysql_id_field": "VehicleType.VehicleTypeID"
        }
    },
    "year": {
        "title": "Year",
        "title_column_name": "Year",
        "description": "Vehicle year",
        "column_name": "year",
        "attribute_name": "year",
        "is_range": true,
        "from_field": "minYear",
        "to_field": "maxYear",
        "vcdb_id": false,
        "default": true,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "baseVehicle.year",
            "id": "baseVehicle.year",
            "result_id_field": "year",
            "mysql_id_field": "YearID",
            "with": {
                "field": "baseVehicle.id",
                "as": "base_vehicle_id"
            }
        }
    },
    "make": {
        "title": "Make",
        "title_column_name": "Make",
        "description": "Vehicle make",
        "column_name": "make",
        "attribute_name": "make",
        "is_range": false,
        "vcdb_id": true,
        "default": true,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "baseVehicle.make.name",
            "id": "baseVehicle.make.id",
            "mysql_id_field": "Make.MakeID",
            "with": {
                "field": "baseVehicle.id",
                "as": "base_vehicle_id"
            }
        }
    },
    "model": {
        "title": "Model",
        "title_column_name": "Model",
        "description": "Vehicle model",
        "column_name": "model",
        "attribute_name": "model",
        "is_range": false,
        "vcdb_id": true,
        "default": true,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "baseVehicle.model.name",
            "id": "baseVehicle.model.id",
            "mysql_id_field": "Model.ModelID",
            "with": {
                "field": "baseVehicle.id",
                "as": "base_vehicle_id"
            }
        }
    },
    "subModel": {
        "title": "Submodel",
        "title_column_name": "Submodel",
        "description": "Vehicle submodel",
        "column_name": "subModel",
        "attribute_name": "subModel",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "subModel.name",
            "id": "subModel.id",
            "mysql_id_field": "Submodel.SubmodelID"
        }
    },
    "engineLiter": {
        "title": "Engine liters",
        "title_column_name": "Eng liters",
        "description": "Measurement of engine displacement in liters",
        "column_name": "engineLiter",
        "attribute_name": "engineLiter",
        "is_range": true,
        "from_field": "minEngineLiter",
        "to_field": "maxEngineLiter",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.liter",
            "id": "engineBase.liter",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.Liter"
        }
    },
    "engineCC": {
        "title": "Engine cubic centimeters",
        "title_column_name": "Eng CC",
        "description": "Measurement of engine displacement in cubic centimeters",
        "column_name": "engineCC",
        "attribute_name": "engineCC",
        "is_range": true,
        "from_field": "minEngineCC",
        "to_field": "maxEngineCC",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.cc",
            "id": "engineBase.cc",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.CC"
        }
    },
    "engineCID": {
        "title": "Engine CID",
        "title_column_name": "Eng CID",
        "description": "Measurement of engine displacement in cubic inches",
        "column_name": "engineCID",
        "attribute_name": "engineCID",
        "is_range": true,
        "from_field": "minEngineCID",
        "to_field": "maxEngineCID",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.cid",
            "id": "engineBase.cid",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.CID"
        }
    },
    "engineBlockType": {
        "title": "Engine block type",
        "title_column_name": "Eng block",
        "description": "Engine block types, such as V, inline, etc.",
        "column_name": "engineBlockType",
        "attribute_name": "engineBlockType",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.block_type",
            "id": "engineBase.block_type",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.BlockType"
        }
    },
    "engineCylinder": {
        "title": "Number of cylinders",
        "title_column_name": "Cylinders",
        "description": "Number of engine cylinders",
        "column_name": "engineCylinder",
        "attribute_name": "engineCylinder",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.cylinders",
            "id": "engineBase.cylinders",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.Cylinders"
        }
    },
    "engineBoreIN": {
        "title": "Engine bore size - inches",
        "title_column_name": "Bore inches",
        "description": "Engine cylinder bore in inches",
        "column_name": "engineBoreIN",
        "attribute_name": "engineBoreIN",
        "is_range": true,
        "from_field": "minEngineBoreIn",
        "to_field": "maxEngineBoreIn",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.bore_inch",
            "id": "engineBase.bore_inch",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.EngBoreIn"
        }
    },
    "engineBoreMT": {
        "title": "Engine bore size - millimeters",
        "title_column_name": "Bore mm",
        "description": "Engine cylinder bore in millimeters",
        "column_name": "engineBoreMT",
        "attribute_name": "engineBoreMT",
        "is_range": true,
        "from_field": "minEngineBoreMT",
        "to_field": "maxEngineBoreMT",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.bore_metric",
            "id": "engineBase.bore_metric",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.EngBoreMetric"
        }
    },
    "engineStrokeIN": {
        "title": "Engine stroke size - inches",
        "title_column_name": "Stroke inches",
        "description": "Engine cylinder stroke in inches",
        "column_name": "engineStrokeIN",
        "attribute_name": "engineStrokeIN",
        "is_range": true,
        "from_field": "minEngineStrokeIN",
        "to_field": "maxEngineStrokeIN",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.stroke_inch",
            "id": "engineBase.stroke_inch",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.EngStrokeIn"
        }
    },
    "engineStrokeMT": {
        "title": "Engine stroke size - meters",
        "title_column_name": "Stroke mm",
        "description": "Engine cylinder stroke in millimeters",
        "column_name": "engineStrokeMT",
        "attribute_name": "engineStrokeMT",
        "is_range": true,
        "from_field": "minEngineStrokeMT",
        "to_field": "maxEngineStrokeMT",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineBase.stroke_metric",
            "id": "engineBase.stroke_metric",
            "result_id_field": "engine_base_id",
            "mysql_id_field": "EngineBase.EngineBaseID",
            "mysql_value_field": "EngineBase.EngStrokeMetric"
        }
    },
    "engineDesignation": {
        "title": "Engine designation",
        "title_column_name": "Eng designation",
        "description": "OE manufacturer unique code to identify engine platform (e.g. LS6, E3, etc.)",
        "column_name": "engineDesignation",
        "attribute_name": "engineDesignation",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineDesignation.name",
            "id": "engineDesignation.id",
            "mysql_id_field": "EngineDesignation.EngineDesignationID"
        }
    },
    "engineVersion": {
        "title": "Engine Version",
        "title_column_name": "Eng version",
        "description": "Engine version (e.g. Windsor, Cleveland, Modified, etc.)",
        "column_name": "engineVersion",
        "attribute_name": "engineVersion",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineVersion.name",
            "id": "engineVersion.id",
            "mysql_id_field": "EngineVersion.EngineVersionID"
        }
    },
    "engineVIN": {
        "title": "Engine VIN",
        "title_column_name": "Eng VIN",
        "description": "Manufacturers code for engine configuration found in VIN (vehicle identification number) (e.g., 2, H, etc.)",
        "column_name": "engineVIN",
        "attribute_name": "engineVIN",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineVIN.name",
            "id": "engineVIN.id",
            "mysql_id_field": "EngineVIN.EngineVINID"
        }
    },
    "engineMfr": {
        "title": "Engine manufacturer",
        "title_column_name": "Eng Mfr",
        "description": "The manufacturer that actually built the engine (e.g., Chevrolet, Cummins, Honda, etc.)",
        "column_name": "engineMfr",
        "attribute_name": "engineMfr",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "engineMfr.name",
            "id": "engineMfr.id",
            "mysql_id_field": "Mfr.MfrID"
        }
    },
    "aspirationName": {
        "title": "Aspiration",
        "title_column_name": "Aspiration",
        "description": "Aspiration or Boost type name (e.g., natural, turbocharger, supercharged, etc.)",
        "column_name": "aspirationName",
        "attribute_name": "aspirationName",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "aspiration.name",
            "id": "aspiration.id",
            "mysql_id_field": "Aspiration.AspirationID",
            "element_name": "Aspiration"
        }
    },
    "ignitionSystemType": {
        "title": "Ignition system type",
        "title_column_name": "Ignition type",
        "description": "Basic ignition system type (e.g., Distributor-Breaker, Distributorless, etc.)",
        "column_name": "ignitionSystemType",
        "attribute_name": "ignitionSystemType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "ignitionSystemType.name",
            "id": "ignitionSystemType.id",
            "mysql_id_field": "IgnitionSystemType.IgnitionSystemTypeID"
        }
    },
    "valvesPerEngine": {
        "title": "Valves per engine",
        "title_column_name": "Valves",
        "description": "Total number of intake and exhaust vales in the engine (e.g., 8, 16, 24, etc.)",
        "column_name": "valvesPerEngine",
        "attribute_name": "valvesPerEngine",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "valve.name",
            "id": "valve.id",
            "mysql_id_field": "Valves.ValvesID"
        }
    },
    "fuelDeliverySubType": {
        "title": "Fuel delivery type",
        "title_column_name": "Fuel del type",
        "description": "Fuel system configuration (e.g., 2BBL - 2 barrel carb, TBI - throttle body injection, etc.)",
        "column_name": "fuelDeliverySubType",
        "attribute_name": "fuelDeliverySubType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "fuelDeliverySubType.name",
            "id": "fuelDeliverySubType.id",
            "mysql_id_field": "FuelDeliverySubType.FuelDeliverySubTypeID"
        }
    },
    "fuelDeliveryType": {
        "title": "Fuel delivery system",
        "title_column_name": "Fuel del sys",
        "description": "Fuel delivery method (e.g., carburetion, fuel injection, etc.)",
        "column_name": "fuelDeliveryType",
        "attribute_name": "fuelDeliveryType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "fuelDeliveryType.name",
            "id": "fuelDeliveryType.id",
            "mysql_id_field": "FuelDeliveryType.FuelDeliveryTypeID"
        }
    },
    "fuelSystemControlType": {
        "title": "Fuel system control type",
        "title_column_name": "Fuel sys ctrl type",
        "description": "Fuel system method of control (e.g., electronic, mechanical, etc.)",
        "column_name": "fuelSystemControlType",
        "attribute_name": "fuelSystemControlType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "fuelSystemControlType.name",
            "id": "fuelSystemControlType.id",
            "mysql_id_field": "FuelSystemControlType.FuelSystemControlTypeID"
        }
    },
    "fuelSystemDesign": {
        "title": "Fuel engine control unit",
        "title_column_name": "Fuel engine ctrl unit",
        "description": "The design or manufacturer of the fuel system (e.g., Holley, Bosch, etc.)",
        "column_name": "fuelSystemDesign",
        "attribute_name": "fuelSystemDesign",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "fuelSystemDesign.name",
            "id": "fuelSystemDesign.id",
            "mysql_id_field": "FuelSystemDesign.FuelSystemDesignID"
        }
    },
    "fuelType": {
        "title": "Fuel type",
        "title_column_name": "Fuel type",
        "description": "Fuel type used in the vehicle (e.g., flex, diesel, gas, etc.)",
        "column_name": "fuelType",
        "attribute_name": "fuelType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "fuelType.name",
            "id": "fuelType.id",
            "mysql_id_field": "FuelType.FuelTypeID"
        }
    },
    "bedLengthIN": {
        "title": "Bed length inches",
        "title_column_name": "Bed length (in)",
        "description": "Pickup bed length represented in inches to one decimal point of precision.",
        "column_name": "bedLengthIN",
        "attribute_name": "bedLengthIN",
        "is_range": true,
        "from_field": "minBedLengthIN",
        "to_field": "maxBedLengthIN",
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "bedLength.length_in",
            "id": "bedLength.length_in",
            "result_id_field": "bed_length_id",
            "mysql_id_field": "BedLength.BedLengthID",
            "mysql_value_field": "BedLength.BedLength"
        }
    },
    "bedLengthMT": {
        "title": "Bed length centimeters",
        "title_column_name": "Bed length (cm)",
        "description": "Pickup bed length represented in centimeters to one decimal point of precision.",
        "column_name": "bedLengthMT",
        "attribute_name": "bedLengthMT",
        "is_range": true,
        "from_field": "minBedLengthMT",
        "to_field": "maxBedLengthMT",
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "bedLength.length_metric",
            "id": "bedLength.length_metric",
            "result_id_field": "bed_length_id",
            "mysql_id_field": "BedLength.BedLengthID",
            "mysql_value_field": "BedLength.BedLengthMetric"
        }
    },
    "bedType": {
        "title": "Bed type",
        "title_column_name": "Bed type",
        "description": "Marketing or industry accepted terminology for bed type (e.g., Styleside or Fleetside)",
        "column_name": "bedType",
        "attribute_name": "bedType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "bedType.name",
            "id": "bedType.id",
            "mysql_id_field": "BedType.BedTypeID"
        }
    },
    "bodyNumberDoors": {
        "title": "Body number of doors",
        "title_column_name": "No. of doors",
        "description": "Number of doors ranging from 0 to 6",
        "column_name": "bodyNumberDoors",
        "attribute_name": "bodyNumberDoors",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "bodyNumDoor.name",
            "id": "bodyNumDoor.id",
            "mysql_id_field": "BodyNumDoors.BodyNumDoorsID",
            "element_name": "BodyNumDoors"
        }
    },
    "bodyType": {
        "title": "Body type",
        "title_column_name": "Body type",
        "description": "Industry accepted name for body type (e.g., coupe, sedan, etc.)",
        "column_name": "bodyType",
        "attribute_name": "bodyType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "bodyType.name",
            "id": "bodyType.id",
            "mysql_id_field": "BodyType.BodyTypeID"
        }
    },
    "mfrBodyCode": {
        "title": "Manufacturer body code",
        "title_column_name": "Mfr body code",
        "description": "OE manufacturers unique code for body platform (e.g., A body, F body, C platform, etc.) Note that not all manufacturers designate body codes.",
        "column_name": "mfrBodyCode",
        "attribute_name": "mfrBodyCode",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "mfrBodyCode.name",
            "id": "mfrBodyCode.id",
            "mysql_id_field": "MfrBodyCode.MfrBodyCodeID"
        }
    },
    "brakeABS": {
        "title": "Brake ABS",
        "title_column_name": "Brake ABS",
        "description": "Brake ABS options (e.g., non-ABS, 2-wheel ABS, or 4-wheel ABS)",
        "column_name": "brakeABS",
        "attribute_name": "brakeABS",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "brakeABS.name",
            "id": "brakeABS.id",
            "mysql_id_field": "BrakeABS.BrakeABSID"
        }
    },
    "brakeSystem": {
        "title": "Brake system",
        "title_column_name": "Brake sys",
        "description": "Brake system types (e.g., manual or power)",
        "column_name": "brakeSystem",
        "attribute_name": "brakeSystem",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "brakeSystem.name",
            "id": "brakeSystem.id",
            "mysql_id_field": "BrakeSystem.BrakeSystemID"
        }
    },
    "frontBrakeType": {
        "title": "Front brake type",
        "title_column_name": "Front brake",
        "description": "Brake type used in the front of vehicle (e.g., disc or drum)",
        "column_name": "frontBrakeType",
        "attribute_name": "frontBrakeType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "frontBrakeType.name",
            "id": "frontBrakeType.id",
            "mysql_id_field": "FrontBrakeType.BrakeTypeID"
        }
    },
    "rearBrakeType": {
        "title": "Rear brake type",
        "title_column_name": "Rear brake",
        "description": "Brake type used in the rear of vehicle (e.g., disc or drum)",
        "column_name": "rearBrakeType",
        "attribute_name": "rearBrakeType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "rearBrakeType.name",
            "id": "rearBrakeType.id",
            "mysql_id_field": "RearBrakeType.BrakeTypeID"
        }
    },
    "frontSpringType": {
        "title": "Front spring type",
        "title_column_name": "Front spring",
        "description": "Suspension spring type in the front of the vehicle (e.g., coil, leaf, air, etc.)",
        "column_name": "frontSpringType",
        "attribute_name": "frontSpringType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "frontSpringType.name",
            "id": "frontSpringType.id",
            "mysql_id_field": "FrontSpringType.SpringTypeID"
        }
    },
    "rearSpringType": {
        "title": "Rear spring type",
        "title_column_name": "Rear spring",
        "description": "Suspension spring type in the rear of the vehicle (e.g., coil, leaf, air, etc.)",
        "column_name": "rearSpringType",
        "attribute_name": "rearSpringType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "rearSpringType.name",
            "id": "rearSpringType.id",
            "mysql_id_field": "RearSpringType.SpringTypeID"
        }
    },
    "steeringSystem": {
        "title": "Steering system",
        "title_column_name": "Steering sys",
        "description": "Steering system types (e.g., manual or power)",
        "column_name": "steeringSystem",
        "attribute_name": "steeringSystem",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "steeringSystem.name",
            "id": "steeringSystem.id",
            "mysql_id_field": "SteeringSystem.SteeringSystemID"
        }
    },
    "steeringType": {
        "title": "Steering type",
        "title_column_name": "Steering type",
        "description": "Steering types (e.g., gear or rack)",
        "column_name": "steeringType",
        "attribute_name": "steeringType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "steeringType.name",
            "id": "steeringType.id",
            "mysql_id_field": "SteeringType.SteeringTypeID"
        }
    },
    "transmissionControlType": {
        "title": "Transmission control type",
        "title_column_name": "Trans ctrl type",
        "description": "Type of transmission or transaxle (e.g., automatic, standard, etc.)",
        "column_name": "transmissionControlType",
        "attribute_name": "transmissionControlType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "transmissionControlType.name",
            "id": "transmissionControlType.id",
            "mysql_id_field": "TransmissionControlType.TransmissionControlTypeID"
        }
    },
    "transmissionMfrCode": {
        "title": "Transmission manufacturer",
        "title_column_name": "Trans Mfr",
        "description": "Manufacturer transmission model or unit designation (e.g., AW70, 4HP22H, etc.)",
        "column_name": "transmissionMfrCode",
        "attribute_name": "transmissionMfrCode",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "transmissionMfrCode.name",
            "id": "transmissionMfrCode.id",
            "mysql_id_field": "TransmissionMfrCode.TransmissionMfrCodeID"
        }
    },
    "transmissionNumSpeeds": {
        "title": "Transmission number of speed",
        "title_column_name": "No. of speeds",
        "description": "Number of forward speeds for transmission or transaxle (e.g., 3, 4, 5, etc.)",
        "column_name": "transmissionNumSpeeds",
        "attribute_name": "transmissionNumSpeeds",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "transmissionNumSpeed.name",
            "id": "transmissionNumSpeed.id",
            "mysql_id_field": "TransmissionNumSpeeds.TransmissionNumSpeedsID"
        }
    },
    "transmissionType": {
        "title": "Transmission type",
        "title_column_name": "Trans type",
        "description": "Transmission or transaxle",
        "column_name": "transmissionType",
        "attribute_name": "transmissionType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "transmissionType.name",
            "id": "transmissionType.id",
            "mysql_id_field": "TransmissionType.TransmissionTypeID"
        }
    },
    "wheelBaseIN": {
        "title": "Wheel base inches",
        "title_column_name": "Wheelbase (in)",
        "description": "Wheelbase length represented in inches to one decimal point of precision.",
        "column_name": "wheelBaseIN",
        "attribute_name": "wheelBaseIN",
        "is_range": true,
        "from_field": "minWheelBaseIN",
        "to_field": "maxWheelBaseIN",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "wheelBase.wheel_base_in",
            "id": "wheelBase.wheel_base_in",
            "result_id_field": "wheel_base_id",
            "mysql_id_field": "WheelBase.WheelBaseID",
            "mysql_value_field": "WheelBase.WheelBase"
        }
    },
    "wheelBaseMT": {
        "title": "Wheel base centimeters",
        "title_column_name": "Wheelbase (cm)",
        "description": "Wheelbase length represented in centimeters to one decimal point of precision.",
        "column_name": "wheelBaseMT",
        "attribute_name": "wheelBaseMT",
        "is_range": true,
        "from_field": "minWheelBaseMT",
        "to_field": "maxWheelBaseMT",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "wheelBase.wheel_base_metric",
            "id": "wheelBase.wheel_base_metric",
            "result_id_field": "wheel_base_id",
            "mysql_id_field": "WheelBase.WheelBaseID",
            "mysql_value_field": "WheelBase.WheelBaseMetric"
        }
    },
    "horsePower": {
        "title": "Horsepower",
        "title_column_name": "HP",
        "description": "Engine power output expressed in horsepower, including a decimal point only when required to represent fractional values.",
        "column_name": "horsePower",
        "attribute_name": "horsePower",
        "is_range": true,
        "from_field": "minHorsePower",
        "to_field": "maxHorsePower",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "powerOutput.horse_power",
            "id": "powerOutput.horse_power",
            "result_id_field": "power_output_id",
            "mysql_id_field": "PowerOutput.PowerOutputID",
            "mysql_value_field": "PowerOutput.HorsePower"
        }
    },
    "kilowattPower": {
        "title": "Kilowatt power",
        "title_column_name": "KP",
        "description": "Engine power output expressed in kilowatt, including a decimal point only when required to represent fractional values.",
        "column_name": "kilowattPower",
        "attribute_name": "kilowattPower",
        "is_range": true,
        "from_field": "minKilowattPower",
        "to_field": "maxKilowattPower",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "powerOutput.kilowatt_power",
            "id": "powerOutput.kilowatt_power",
            "result_id_field": "power_output_id",
            "mysql_id_field": "PowerOutput.PowerOutputID",
            "mysql_value_field": "PowerOutput.KilowattPower"
        }
    },
    "cylinderHeadType": {
        "title": "Cylinder head type",
        "title_column_name": "Cyl head type",
        "description": "Value of cylinder head name (e.g., SOHC - single overhead cam, DOHC - dual overhead cam, and OHV - overhead valve)",
        "column_name": "cylinderHeadType",
        "attribute_name": "cylinderHeadType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "cylinderHeadType.name",
            "id": "cylinderHeadType.id",
            "mysql_id_field": "CylinderHeadType.CylinderHeadTypeID"
        }
    },
    "driveType": {
        "title": "Drive type",
        "title_column_name": "Drive type",
        "description": "Description of drive type (e.g., FWD - front wheel drive, RWD - rear wheel drive, AWD - all wheel drive, etc.)",
        "column_name": "driveType",
        "attribute_name": "driveType",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "driveType.name",
            "id": "driveType.id",
            "mysql_id_field": "DriveType.DriveTypeID"
        }
    },
    "elecControlled": {
        "title": "Transmission electronically controlled",
        "title_column_name": "Trans elec ctrl",
        "description": "Yes or No on whether transmission is electronically controlled.",
        "column_name": "elecControlled",
        "attribute_name": "elecControlled",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "elecControlled.name",
            "id": "elecControlled.id",
            "mysql_id_field": "ElecControlled.ElecControlledID",
            "element_name": "TransElecControlled"
        }
    },
    "qty": {
        "title": "Qty",
        "description": "Quantity Per Position",
        "column_name": "qty",
        "attribute_name": "qty",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "fitment_02_specific": true,
        "app_doc_map": {
            "name": "qty",
            "id": "qty"
        }
    },
    "notes": {
        "title": "Notes",
        "description": "",
        "column_name": "notes",
        "attribute_name": "notes",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "fitment_02_specific": true,
        "app_doc_map": {
            "name": "notes",
            "id": "notes"
        }
    },
    "position": {
        "title": "Position",
        "description": "",
        "column_name": "position",
        "attribute_name": "position",
        "is_range": false,
        "vcdb_id": true,
        "default": false,
        "data_format": null,
        "example": null,
        "fitment_02_specific": true,
        "app_doc_map": {
            "name": "position",
            "id": "position.id",
            "mysql_id_field": "Positions.PositionID"
        }
    },
    "mfrLabel": {
        "title": "Manufacturer Label",
        "description": "",
        "column_name": "mfrLabel",
        "attribute_name": "mfrLabel",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "fitment_02_specific": true,
        "app_doc_map": {
            "name": "mfr_label",
            "id": "mfr_label"
        }
    },
    "validationError": {
        "title": "Validation",
        "description": "",
        "column_name": "validationError",
        "title_column_name": "Validation Error",
        "attribute_name": "validationError",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "display_method": "validationError.options",
            "name": "vcdb_error_status",
            "id": "vcdb_error_status"
        }
    },
    "createdDate": {
        "title": "Created Date",
        "description": "",
        "column_name": "createdDate",
        "title_column_name": "Created Date",
        "attribute_name": "createdDate",
        "is_range": true,
        "from_field": "minCreatedDate",
        "to_field": "maxCreatedDate",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "date_picker": true,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "name": "created_at",
            "id": "created_at"
        }
    },
    "modifiedDate": {
        "title": "Modified Date",
        "description": "",
        "column_name": "modifiedDate",
        "title_column_name": "Modified Date",
        "attribute_name": "modifiedDate",
        "is_range": true,
        "from_field": "minModifiedDate",
        "to_field": "maxModifiedDate",
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "date_picker": true,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "name": "updated_at",
            "id": "updated_at"
        }
    },
    "partNumber": {
        "title": "Part Number",
        "description": "",
        "column_name": "partNumber",
        "title_column_name": "Part Number",
        "attribute_name": "partNumber",
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "options": [
          {
            "option": 'BMH05RBS',
            "title": 'BMH05RBS',
          },
          {
            "option": 'BRC99SBK',
            "title": 'BRC99SBK',
          },
          {
            "option": 'BMQ04SCD',
            "title": 'BMQ04SCD',
          },
          {
            "option": 'UTT09CCK',
            "title": 'UTT09CCK',
          },
        ],
        "app_doc_map": {
            "name": "partNumber",
            "id": "partNumber"
        }
    },
    "partType": {
        "title": "Part Type",
        "description": "",
        "column_name": "partType",
        "title_column_name": "Part Type",
        "attribute_name": "partType",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "name": "partTerminology.name",
            "id": "partTerminology.id"
        }
    },
    "partTerminologyId": {
        "title": "Part Terminology ID",
        "description": "",
        "column_name": "partTerminologyId",
        "title_column_name": "Part Terminology ID",
        "attribute_name": "partTerminologyId",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "name": "partTerminology.id",
            "id": "partTerminology.id"
        }
    },
    "lifeCycleStatus": {
        "title": "Life Cycle Status",
        "description": "",
        "column_name": "lifeCycleStatus",
        "title_column_name": "Life Cycle Status",
        "attribute_name": "lifeCycleStatus",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "display_method": "lifeCycle.options",
            "name": "extendedInformation.LIF",
            "id": "extendedInformation.LIF"
        }
    },
    "popularityCode": {
        "title": "Popularity Code",
        "description": "",
        "column_name": "popularityCode",
        "title_column_name": "Popularity Code",
        "attribute_name": "popularityCode",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "app_doc_map": {
            "name": "extendedInformation.NPC",
            "id": "extendedInformation.NPC"
        }
    },
    "msdsRequired": {
        "title": "MSDS required",
        "description": "",
        "column_name": "msdsRequired",
        "title_column_name": "MSDS required",
        "attribute_name": "msdsRequired",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "name": "extendedInformation.MSR",
            "id": "extendedInformation.MSR"
        }
    },
    "acesApplication": {
        "title": "ACES Application",
        "description": "",
        "column_name": "acesApplication",
        "title_column_name": "ACES Application",
        "attribute_name": "acesApplication",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "app_doc_map": {
            "display_method": "hasFitments.options",
            "name": "details.hasFitments",
            "id": "details.hasFitments"
        }
    },
    "description": {
        "title": "Descriptions",
        "description": "",
        "column_name": "description",
        "title_column_name": "Description",
        "attribute_name": "description",
        "is_text_select": true,
        "text_field_name": "descriptionText",
        "select_field_name": "description",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "multiple_lang_support": true,
        "app_doc_map": {
            "display_method": "description.options",
            "name": "descriptions.{select_field_name}",
            "id": "descriptions.{select_field_name}"
        }
    },
    "productGroup": {
        "title": "Product Group",
        "description": "",
        "column_name": "productGroup",
        "title_column_name": "Product Group",
        "attribute_name": "productGroup",
        "check_for_null": true,
        "is_range": false,
        "vcdb_id": false,
        "default": false,
        "data_format": null,
        "example": null,
        "item_detail_specific": true,
        "nested_fields": [
          {
              "prodSubGroup": {
                  "title": "Sub Group",
                  "description": "",
                  "column_name": "subGroup",
                  "title_column_name": "Product Sub Group",
                  "attribute_name": "subGroup",
                  "check_for_null": true,
                  "is_range": false,
                  "vcdb_id": false,
                  "default": false,
                  "data_format": null,
                  "example": null,
                  "item_detail_specific": true,
                  "order_index": 2,
                  "app_doc_map": {
                      "name": "details.group.subGroup.name||details.group.subGroup.code",
                      "id": "details.group.subGroup.code"
                  }
              }
          },
            {
                "prodGroup": {
                    "title": "Group",
                    "description": "",
                    "column_name": "group",
                    "title_column_name": "Product Group",
                    "attribute_name": "group",
                    "check_for_null": true,
                    "is_range": false,
                    "vcdb_id": false,
                    "default": false,
                    "data_format": null,
                    "example": null,
                    "item_detail_specific": true,
                    "order_index": 1,
                    "options": [
                      {
                        "option": '001',
                        "title": 'Product group 1',
                      },
                      {
                        "option": '002',
                        "title": 'Product group 2',
                      },
                    ],
                    "app_doc_map": {
                        "name": "details.group.name||details.group.code",
                        "id": "details.group.code"
                    }
                }
            }
        ]
    }
};

export const validationErrorStub = [
  {
    "option": 'invalid-items',
    "title": "Product PIES invalid",
  },
  {
    "option": 'invalid-pies-65',
    "title": "Product PIES 6.5 invalid",
  },
  {
    "option": 'invalid-pies-67',
    "title": "Product PIES 6.7 invalid",
  },
  {
    "option": 'invalid-pies-70',
    "title": "Product PIES 7.0 invalid",
  },
  {
    "option": 'invalid-apps',
    "title": "Fitment invalid",
  },
  {
    "option": 'missing-primary-photo',
    "title": "Missing Primary Photo",
  },
  {
    "option": 'invalid-app-part-terms',
    "title": "Invalid fitments part types",
  },
  {
    "option": 'invalid-app-qualifier',
    "title": "Invalid fitments qualifiers",
  },
];

/* eslint-enable */
